import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";

const ReassignSelect = ({
  role,
  availableOptions,
  selectedOptions,
  onChange,
}) => {
  return (
    <tr>
      <td>{role}</td>
      <td>
        <Select
          isMulti
          options={availableOptions.map((value) => ({
            value,
            label: value,
          }))}
          value={
            selectedOptions != null &&
            selectedOptions.map((status) => ({
              value: status,
              label: status,
            }))
          }
          onChange={(selected) =>
            onChange(selected ? selected.map((option) => option.value) : [])
          }
          placeholder={`Select permission(s)`}
        />
      </td>
    </tr>
  );
};

const ReassignWorkflowPermission = ({
  data,
  setData,
  availableOptionsAvailability,
}) => {
  const handleChange = (role, selected) => {
    setData({
      ...data,
      [`Selected${role}Permissions`]: selected,
    });
  };

  return (
    <div>
      <div className="workflow-modal-description-title mb-3">
        Permission Conditions
      </div>
      <div>
        <table>
          <thead>
            <tr>
              <th>Permissions</th>
              <th>Can Re-Assign </th>
            </tr>
          </thead>
          <tbody>
            <ReassignSelect
              role="Owner"
              availableOptions={availableOptionsAvailability}
              selectedOptions={data.SelectedOwnerPermissions}
              onChange={(selected) => handleChange("Owner", selected)}
            />
            <ReassignSelect
              role="Approver"
              availableOptions={availableOptionsAvailability}
              selectedOptions={data.SelectedApproverPermissions}
              onChange={(selected) => handleChange("Approver", selected)}
            />
            <ReassignSelect
              role="Editor"
              availableOptions={availableOptionsAvailability}
              selectedOptions={data.SelectedEditorPermissions}
              onChange={(selected) => handleChange("Editor", selected)}
            />
            <ReassignSelect
              role="Viewer"
              availableOptions={availableOptionsAvailability}
              selectedOptions={data.SelectedViewerPermissions}
              onChange={(selected) => handleChange("Viewer", selected)}
            />
          </tbody>
        </table>
      </div>
    </div>
  );
};

ReassignWorkflowPermission.propTypes = {
  data: PropTypes.shape({
    SelectedOwnerPermissions: PropTypes.arrayOf(PropTypes.string),
    SelectedApproverPermissions: PropTypes.arrayOf(PropTypes.string),
    SelectedEditorPermissions: PropTypes.arrayOf(PropTypes.string),
    SelectedViewerPermissions: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  setData: PropTypes.func.isRequired,
  availableOptionsAvailability: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ReassignWorkflowPermission;
